import Container from "react-bootstrap/Container";
import { useNavigate, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button, NavDropdown } from "react-bootstrap";
import { useAppContext } from "../../context/app-context";
import { useEffect, useState } from "react";
import "./header.css";
import Services from "../../pages/services/services";
import HireTeam from "../../pages/hire-developers/hire-developer";
import logoUrl from "../../images/acube-logo-blue.svg";
import closeMenu from "../../images/close-menu.svg";


function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        showMegaMenu,
        setShowMegaMenu,
        navbarExpanded,
        setNavbarExpanded,
        setDropdownTitleActive,
    } = useAppContext();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    const {
        selectedNavItem,
        setSelectedNavItem,
        tempSelectedTitle,
        setTempSelectedTitle,
    } = useAppContext();
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setNavbarExpanded(false);
        setShowMegaMenu({ services: false, hireTeam: false });
    }, [location, setShowMegaMenu, setNavbarExpanded]);

    const handlePageLink = (path, title) => {
        navigate(path);
        setSelectedNavItem(title);
        setShowMegaMenu({ services: false, hireTeam: false }); // Close any open mega menus
        setNavbarExpanded(false);
        setDropdownTitleActive(title);
        setTempSelectedTitle("");
    };

    const closeMegaMenu = () => {
        setShowMegaMenu({ services: false, hireTeam: false });
    };

    const toggleMegaMenu = (menu) => {
        setShowMegaMenu((prevState) => ({
            services: menu === "services" ? !prevState.services : false,
            hireTeam: menu === "hireTeam" ? !prevState.hireTeam : false,
        }));
        setTempSelectedTitle(menu);
    };

    const handleHomePageScroll = (path) => {
        if (location.pathname === path) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            handlePageLink(path, "home");
        }
        setNavbarExpanded(false);
        setShowMegaMenu({ services: false, hireTeam: false });
    };

    const handleDropdownClick = (e, pagename) => {
        closeMegaMenu(); // Close mega menus when a dropdown is clicked
        setTempSelectedTitle(pagename);
    };
    return (
        <Navbar
            collapseOnSelect
            expand="xl"
            className={`bg-body-tertiary page-header fixed-top ${navbarExpanded ? "show" : ""
                }`}
            expanded={navbarExpanded}
        >
            <Container fluid className="header-nav-items">
                <Navbar.Brand onClick={() => handleHomePageScroll("/")}>
                    <img
                        src={logoUrl}
                        alt="logo"
                        width="130"
                        height="45"
                        className="img-fluid d-block d-lg-none"
                    />
                    <img
                        src={logoUrl}
                        alt="logo"
                        width="192"
                        height="45"
                        className="img-fluid d-none d-lg-block"
                    />
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="responsive-navbar-nav"
                    onClick={() => setNavbarExpanded(!navbarExpanded)}
                />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-0 ms-lg-auto mt-3 mt-xl-0">
                        <Nav.Link
                            onClick={() => toggleMegaMenu("hireTeam")}
                            className={
                                selectedNavItem === "hireTeam"
                                    ? "title-active"
                                    : tempSelectedTitle === "hireTeam"
                                        ? "active-dropdown-color"
                                        : ""
                            }
                        >
                            Hire Developers
                        </Nav.Link>
                        {isMobile && showMegaMenu.hireTeam && (
                            <div className="mobile-mega-menu pt-1">
                                <HireTeam isMegaMenu={true} closeMegaMenu={closeMegaMenu} />
                            </div>
                        )}
                        <Nav.Link
                            onClick={() => toggleMegaMenu("services")}
                            className={
                                selectedNavItem === "services"
                                    ? "title-active"
                                    : tempSelectedTitle === "services"
                                        ? "active-dropdown-color"
                                        : ""
                            }
                        >
                            Services
                        </Nav.Link>
                        {isMobile && showMegaMenu.services && (
                            <div className="mobile-mega-menu pt-1 services-menu">
                                <Services isMegaMenu={true} closeMegaMenu={closeMegaMenu} />
                            </div>
                        )}

                        <NavDropdown
                            title="Products"
                            id="products-dropdown"
                            onClick={(e) => handleDropdownClick(e, "products")}
                            className={`custom-nav-menu ${selectedNavItem === "products"
                                ? "title-active"
                                : tempSelectedTitle === "products"
                                    ? "active-dropdown-color"
                                    : ""
                                }`}
                        >
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/products/medrixo", "products")}
                            >
                                Medrixo
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/products/tax_solutions", "products")}
                            >
                                Taxongo
                            </NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown
                            title="Resources"
                            id="resources-dropdown"
                            onClick={() => handleDropdownClick("resources")}
                            className={`custom-nav-menu ${selectedNavItem === "resources"
                                ? "title-active"
                                : tempSelectedTitle === "resources"
                                    ? "active-dropdown-color"
                                    : ""
                                }`}
                        >
                            <NavDropdown.Item
                                onClick={() =>
                                    handlePageLink("resources/case_study", "resources")
                                }
                            >
                                Case Studies
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/resources/portfolio", "resources")}
                            >
                                Portfolio
                            </NavDropdown.Item>
                            {/* <NavDropdown.Item
                                onClick={() => handlePageLink("/resources/article", "resources")}
                            >
                                Articles
                            </NavDropdown.Item> */}
                        </NavDropdown>
                        <NavDropdown
                            title="Company"
                            id="company-dropdown"
                            onClick={() => handleDropdownClick("company")}
                            className={`custom-nav-menu ${selectedNavItem === "company"
                                ? "title-active"
                                : tempSelectedTitle === "company"
                                    ? "active-dropdown-color"
                                    : ""
                                }`}
                        >
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/company/about_us", "company")}
                            >
                                About Us
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/company/join_us", "company")}
                            >
                                Join Us
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() =>
                                    handlePageLink("/company/development_center", "company")
                                }
                            >
                                Development Center
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/company/about_us/our-team", "company")}
                            >
                                Our Team
                            </NavDropdown.Item>
                            <NavDropdown.Item
                                onClick={() => handlePageLink("/company/contact_us", "company")}
                            >
                                Contact Us
                            </NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link
                            className="nav-btn px-2 pt-0 pb-2 position-relative"
                            href="https://calendly.com/sairam-acubetechnologies"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button variant="primary" className="text-uppercase">
                                Hire Developers
                            </Button>
                            <div className="blinking-dot">We are Online</div>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
            {!isMobile && (
                <>
                    {showMegaMenu?.services ? (
                        <div className="mega-menu">
                            <div className="mega-menu-header">
                                <Button
                                    variant="link"
                                    className="close-btn"
                                    onClick={closeMegaMenu}
                                >
                                    <img src={closeMenu} alt="close" />
                                </Button>
                            </div>
                            <Services isMegaMenu={true} closeMegaMenu={closeMegaMenu} />
                        </div>
                    ) : showMegaMenu?.hireTeam ? (
                        <div className="mega-menu">
                            <div className="mega-menu-header">
                                <Button
                                    variant="link"
                                    className="close-btn"
                                    onClick={closeMegaMenu}
                                >
                                    <img src={closeMenu} alt="close" />
                                </Button>
                            </div>
                            <HireTeam isMegaMenu={true} closeMegaMenu={closeMegaMenu} />
                        </div>
                    ) : null}
                </>
            )}
        </Navbar>
    );
}

export default Header;
